import React from 'react';
import PropTypes from 'prop-types';
import MarketplaceProductCard, { KetoProductCard } from '@nerdwallet/react-marketplace-product-card';
var MarketplaceProductCardContext = /*#__PURE__*/React.createContext({});
export default MarketplaceProductCardContext;
/**
 * Defines a context to pass props to MarketplaceProductCard and KetoProductCard where
 * not normally available through structured-content.
 */

var MarketplaceProductCardContextProvider = function MarketplaceProductCardContextProvider(_ref) {
  var props = _ref.props,
      ketoProps = _ref.ketoProps,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(MarketplaceProductCardContext.Provider, {
    value: {
      props: props,
      ketoProps: ketoProps
    }
  }, children);
};

MarketplaceProductCardContextProvider.defaultProps = {
  props: {},
  ketoProps: {}
};
MarketplaceProductCardContextProvider.propTypes = {
  props: PropTypes.shape(MarketplaceProductCard.propTypes),
  ketoProps: PropTypes.shape(KetoProductCard.propTypes),
  children: PropTypes.node.isRequired
};
export { MarketplaceProductCardContextProvider };